export function formatTelNrSimple(tel: string): string {
  if (!helpers.isString(tel)) {
    return tel
  }
  if (tel.startsWith('+370') && tel.length === 12) {
    return [...tel.substr(0, 4), ' ', ...tel.substr(4, 3), ' ', ...tel.substr(7, 5)].join('')
  }
  if (tel.startsWith('86') && tel.length === 9) {
    return [tel[0], ' ', ...tel.substr(1, 3), ' ', ...tel.substr(4, 5)].join('')
  }

  return tel
}
